// Seeded random for everything that affects the simulation, so a replay with
// the same seed and input plays out identically. Sounds and cosmetic effects
// keep Math.random: they may run a different number of times per platform.
let state = 0;

export const seedGameRandom = seed => {
	state = seed | 0;
};

export const createGameSeed = () => (Math.random() * 0x100000000) >>> 0;

export const gameRandomState = () => state;

// mulberry32
export const gameRandom = () => {
	state = (state + 0x6D2B79F5) | 0;
	let t = state;
	t = Math.imul(t ^ (t >>> 15), t | 1);
	t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
	return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};
